import styled from "styled-components";

export const ReadOnlyStyle = styled.div`
  width: 100%;
  p{margin:0}
`;
